__turbopack_context__.v({
  "l2": "QoFRia_l2",
  "loader": "QoFRia_loader",
  "loadingCtn": "QoFRia_loadingCtn",
});
